webpackJsonp([153585907648654],{

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var philosophers = [{ id: 1, forks: [1, 5] }, { id: 2, forks: [1, 2] }, { id: 3, forks: [2, 3] }, { id: 4, forks: [3, 4] }, { id: 5, forks: [4, 5] }];
	
	var getPhase = function getPhase(states, id) {
	  if (states.indexOf('P' + id + '_Eating') > -1) return 'eating';
	  if (states.indexOf('P' + id + '_HasFirst') > -1) return 'holding one';
	  if (states.indexOf('P' + id + '_Hungry') > -1) return 'hungry';
	  return 'thinking';
	};
	
	var phaseStyle = function phaseStyle(phase) {
	  if (phase === 'eating') return { background: '#1f7a4d', color: '#fff' };
	  if (phase === 'holding one') return { background: '#f2b84b', color: '#2b210f' };
	  if (phase === 'hungry') return { background: '#d9534f', color: '#fff' };
	  return { background: '#e9ecef', color: '#333' };
	};
	
	var DiningPhilosophersPanel = function DiningPhilosophersPanel(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel,
	      log = _ref.log,
	      onEvent = _ref.onEvent,
	      onReset = _ref.onReset;
	
	  var states = configuration || [];
	  var forks = datamodel && datamodel.forks ? datamodel.forks : [0, 0, 0, 0, 0, 0];
	  var eatCount = datamodel && datamodel.eatCount ? datamodel.eatCount : [0, 0, 0, 0, 0, 0];
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f7f7f7', overflow: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'h3',
	        { style: { margin: 0 } },
	        'Dining table'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-light btn-sm', onClick: onReset },
	        'Reset'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.4rem', marginBottom: '1rem' } },
	      [1, 2, 3, 4, 5].map(function (id) {
	        return _react2.default.createElement(
	          'div',
	          { key: id, style: { background: '#fff', border: '1px solid #ddd', padding: '0.45rem', textAlign: 'center' } },
	          _react2.default.createElement(
	            'div',
	            { style: { fontWeight: 'bold' } },
	            'Fork ',
	            id
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            forks[id] ? 'P' + forks[id] : 'free'
	          )
	        );
	      })
	    ),
	    philosophers.map(function (_ref2) {
	      var id = _ref2.id,
	          pair = _ref2.forks;
	
	      var phase = getPhase(states, id);
	      return _react2.default.createElement(
	        'div',
	        { key: id, style: { background: '#fff', border: '1px solid #ddd', padding: '0.75rem', marginBottom: '0.65rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' } },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Philosopher ',
	            id
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: _extends({ borderRadius: '2px', padding: '0.2rem 0.45rem', fontSize: '0.8rem' }, phaseStyle(phase)) },
	            phase
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { color: '#666', fontSize: '0.9rem', marginBottom: '0.5rem' } },
	          'Uses forks ',
	          pair[0],
	          ' and ',
	          pair[1],
	          '; has eaten ',
	          eatCount[id] || 0,
	          ' time',
	          eatCount[id] === 1 ? '' : 's',
	          '.'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-primary btn-sm',
	            style: { marginRight: '0.35rem' },
	            disabled: phase !== 'thinking',
	            onClick: function onClick() {
	              return onEvent('hungry.' + id);
	            }
	          },
	          'Hungry'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-secondary btn-sm',
	            style: { marginRight: '0.35rem' },
	            disabled: phase === 'thinking' || phase === 'eating',
	            onClick: function onClick() {
	              return onEvent('retry.' + id);
	            }
	          },
	          'Retry'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn-success btn-sm',
	            disabled: phase !== 'eating',
	            onClick: function onClick() {
	              return onEvent('done.' + id);
	            }
	          },
	          'Done eating'
	        )
	      );
	    }),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Trace'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	      (log || []).map(function (entry, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: entry + '-' + index, style: { padding: '0.3rem 0', borderTop: index ? '1px solid #e2e2e2' : 0 } },
	          entry
	        );
	      })
	    )
	  );
	};
	
	exports.default = DiningPhilosophersPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"DiningPhilosophers\"\n       name=\"DiningPhilosophers\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data id=\"forks\" expr=\"[0, 0, 0, 0, 0, 0]\"/>\n    <data id=\"eatCount\" expr=\"[0, 0, 0, 0, 0, 0]\"/>\n  </datamodel>\n\n  <parallel id=\"DiningPhilosophers\">\n    <state id=\"P1\" initial=\"P1_Thinking\">\n      <state id=\"P1_Thinking\">\n        <transition event=\"hungry.1\" target=\"P1_Hungry\"/>\n      </state>\n      <state id=\"P1_Hungry\">\n        <transition cond=\"forks[1] == 0\" target=\"P1_HasFirst\"/>\n        <transition event=\"done.* retry.1\" cond=\"forks[1] == 0\" target=\"P1_HasFirst\"/>\n      </state>\n      <state id=\"P1_HasFirst\">\n        <onentry>\n          <assign location=\"forks[1]\" expr=\"1\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 1 picked up fork 1'\"/></send>\n        </onentry>\n        <transition cond=\"forks[5] == 0\" target=\"P1_Eating\"/>\n        <transition event=\"done.* retry.1\" cond=\"forks[5] == 0\" target=\"P1_Eating\"/>\n      </state>\n      <state id=\"P1_Eating\">\n        <onentry>\n          <assign location=\"forks[5]\" expr=\"1\"/>\n          <assign location=\"eatCount[1]\" expr=\"eatCount[1] + 1\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 1 is eating'\"/></send>\n        </onentry>\n        <transition event=\"done.1\" target=\"P1_Thinking\">\n          <assign location=\"forks[1]\" expr=\"0\"/>\n          <assign location=\"forks[5]\" expr=\"0\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 1 put down forks 1 and 5'\"/></send>\n        </transition>\n      </state>\n    </state>\n\n    <state id=\"P2\" initial=\"P2_Thinking\">\n      <state id=\"P2_Thinking\">\n        <transition event=\"hungry.2\" target=\"P2_Hungry\"/>\n      </state>\n      <state id=\"P2_Hungry\">\n        <transition cond=\"forks[1] == 0\" target=\"P2_HasFirst\"/>\n        <transition event=\"done.* retry.2\" cond=\"forks[1] == 0\" target=\"P2_HasFirst\"/>\n      </state>\n      <state id=\"P2_HasFirst\">\n        <onentry>\n          <assign location=\"forks[1]\" expr=\"2\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 2 picked up fork 1'\"/></send>\n        </onentry>\n        <transition cond=\"forks[2] == 0\" target=\"P2_Eating\"/>\n        <transition event=\"done.* retry.2\" cond=\"forks[2] == 0\" target=\"P2_Eating\"/>\n      </state>\n      <state id=\"P2_Eating\">\n        <onentry>\n          <assign location=\"forks[2]\" expr=\"2\"/>\n          <assign location=\"eatCount[2]\" expr=\"eatCount[2] + 1\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 2 is eating'\"/></send>\n        </onentry>\n        <transition event=\"done.2\" target=\"P2_Thinking\">\n          <assign location=\"forks[1]\" expr=\"0\"/>\n          <assign location=\"forks[2]\" expr=\"0\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 2 put down forks 1 and 2'\"/></send>\n        </transition>\n      </state>\n    </state>\n\n    <state id=\"P3\" initial=\"P3_Thinking\">\n      <state id=\"P3_Thinking\">\n        <transition event=\"hungry.3\" target=\"P3_Hungry\"/>\n      </state>\n      <state id=\"P3_Hungry\">\n        <transition cond=\"forks[2] == 0\" target=\"P3_HasFirst\"/>\n        <transition event=\"done.* retry.3\" cond=\"forks[2] == 0\" target=\"P3_HasFirst\"/>\n      </state>\n      <state id=\"P3_HasFirst\">\n        <onentry>\n          <assign location=\"forks[2]\" expr=\"3\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 3 picked up fork 2'\"/></send>\n        </onentry>\n        <transition cond=\"forks[3] == 0\" target=\"P3_Eating\"/>\n        <transition event=\"done.* retry.3\" cond=\"forks[3] == 0\" target=\"P3_Eating\"/>\n      </state>\n      <state id=\"P3_Eating\">\n        <onentry>\n          <assign location=\"forks[3]\" expr=\"3\"/>\n          <assign location=\"eatCount[3]\" expr=\"eatCount[3] + 1\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 3 is eating'\"/></send>\n        </onentry>\n        <transition event=\"done.3\" target=\"P3_Thinking\">\n          <assign location=\"forks[2]\" expr=\"0\"/>\n          <assign location=\"forks[3]\" expr=\"0\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 3 put down forks 2 and 3'\"/></send>\n        </transition>\n      </state>\n    </state>\n\n    <state id=\"P4\" initial=\"P4_Thinking\">\n      <state id=\"P4_Thinking\">\n        <transition event=\"hungry.4\" target=\"P4_Hungry\"/>\n      </state>\n      <state id=\"P4_Hungry\">\n        <transition cond=\"forks[3] == 0\" target=\"P4_HasFirst\"/>\n        <transition event=\"done.* retry.4\" cond=\"forks[3] == 0\" target=\"P4_HasFirst\"/>\n      </state>\n      <state id=\"P4_HasFirst\">\n        <onentry>\n          <assign location=\"forks[3]\" expr=\"4\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 4 picked up fork 3'\"/></send>\n        </onentry>\n        <transition cond=\"forks[4] == 0\" target=\"P4_Eating\"/>\n        <transition event=\"done.* retry.4\" cond=\"forks[4] == 0\" target=\"P4_Eating\"/>\n      </state>\n      <state id=\"P4_Eating\">\n        <onentry>\n          <assign location=\"forks[4]\" expr=\"4\"/>\n          <assign location=\"eatCount[4]\" expr=\"eatCount[4] + 1\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 4 is eating'\"/></send>\n        </onentry>\n        <transition event=\"done.4\" target=\"P4_Thinking\">\n          <assign location=\"forks[3]\" expr=\"0\"/>\n          <assign location=\"forks[4]\" expr=\"0\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 4 put down forks 3 and 4'\"/></send>\n        </transition>\n      </state>\n    </state>\n\n    <state id=\"P5\" initial=\"P5_Thinking\">\n      <state id=\"P5_Thinking\">\n        <transition event=\"hungry.5\" target=\"P5_Hungry\"/>\n      </state>\n      <state id=\"P5_Hungry\">\n        <transition cond=\"forks[4] == 0\" target=\"P5_HasFirst\"/>\n        <transition event=\"done.* retry.5\" cond=\"forks[4] == 0\" target=\"P5_HasFirst\"/>\n      </state>\n      <state id=\"P5_HasFirst\">\n        <onentry>\n          <assign location=\"forks[4]\" expr=\"5\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 5 picked up fork 4'\"/></send>\n        </onentry>\n        <transition cond=\"forks[5] == 0\" target=\"P5_Eating\"/>\n        <transition event=\"done.* retry.5\" cond=\"forks[5] == 0\" target=\"P5_Eating\"/>\n      </state>\n      <state id=\"P5_Eating\">\n        <onentry>\n          <assign location=\"forks[5]\" expr=\"5\"/>\n          <assign location=\"eatCount[5]\" expr=\"eatCount[5] + 1\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 5 is eating'\"/></send>\n        </onentry>\n        <transition event=\"done.5\" target=\"P5_Thinking\">\n          <assign location=\"forks[4]\" expr=\"0\"/>\n          <assign location=\"forks[5]\" expr=\"0\"/>\n          <send event=\"trace\"><content expr=\"'Philosopher 5 put down forks 4 and 5'\"/></send>\n        </transition>\n      </state>\n    </state>\n  </parallel>\n</scxml>\n"

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.diningPhilosophersScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _diningPhilosophersPanel = __webpack_require__(382);
	
	var _diningPhilosophersPanel2 = _interopRequireDefault(_diningPhilosophersPanel);
	
	var _diningPhilosophers = __webpack_require__(881);
	
	var _diningPhilosophers2 = _interopRequireDefault(_diningPhilosophers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.diningPhilosophersScxml = _diningPhilosophers2.default;
	
	var DiningPhilosophersExample = function (_React$Component) {
	  _inherits(DiningPhilosophersExample, _React$Component);
	
	  function DiningPhilosophersExample(props) {
	    _classCallCheck(this, DiningPhilosophersExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      log: []
	    };
	    return _this;
	  }
	
	  DiningPhilosophersExample.prototype.componentDidMount = function componentDidMount() {
	    this.start();
	  };
	
	  DiningPhilosophersExample.prototype.start = function start() {
	    var _this2 = this;
	
	    this.setState({ log: [] });
	
	    _scxml2.default.documentStringToModel(null, _diningPhilosophers2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  DiningPhilosophersExample.prototype.customSend = function customSend(event) {
	    if (event.name === 'trace') {
	      this.appendLog(event.data);
	    } else {
	      this.sc.gen(event);
	    }
	  };
	
	  DiningPhilosophersExample.prototype.appendLog = function appendLog(entry) {
	    if (!entry) return;
	    this.setState(function (_ref) {
	      var log = _ref.log;
	      return { log: log.concat(entry).slice(-12) };
	    });
	  };
	
	  DiningPhilosophersExample.prototype.send = function send(event) {
	    if (this.sc) this.sc.gen(event);
	  };
	
	  DiningPhilosophersExample.prototype.reset = function reset() {
	    this.start();
	  };
	
	  DiningPhilosophersExample.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '720px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '720px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _diningPhilosophers2.default,
	            disableAnimation: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'dining-philosophers'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '720px', border: '1px solid #eee' } },
	          _react2.default.createElement(_diningPhilosophersPanel2.default, {
	            configuration: this.state.configuration,
	            datamodel: this.state.datamodel,
	            log: this.state.log,
	            onEvent: function onEvent(event) {
	              return _this3.send(event);
	            },
	            onReset: function onReset() {
	              return _this3.reset();
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return DiningPhilosophersExample;
	}(_react2.default.Component);
	
	exports.default = DiningPhilosophersExample;

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _diningPhilosophersExample = __webpack_require__(383);
	
	var _diningPhilosophersExample2 = _interopRequireDefault(_diningPhilosophersExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var DiningPhilosophers = function DiningPhilosophers(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports Alex Zhornyak\'s Qt Dining Philosophers example into a live browser model. The chart demonstrates Dijkstra\'s resource hierarchy solution by requiring each philosopher to acquire the lower-numbered fork before the higher-numbered fork.'
	    ),
	    React.createElement(_diningPhilosophersExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _diningPhilosophersExample.diningPhilosophersScxml
	    )
	  );
	};
	
	var WrappedDiningPhilosophers = function WrappedDiningPhilosophers(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: DiningPhilosophers, pathname: location.pathname });
	};
	
	exports.default = WrappedDiningPhilosophers;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-dining-philosophers-js-5a7db46275582bf0dec7.js